import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services';
import { ConfService } from 'src/conf.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService  implements HttpInterceptor {

  constructor(private authservice: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.startsWith(ConfService.conf.environment.apiRootUrl) && this.authservice.isTokenExpired())
     {
      alert('Your session has ended you will be redirected to the login screen');
      this.authservice.signOut();
      return;
    }
    if (req.method === "GET") {
      let userIdToken = "";
      //if (req.url == environment.UserTokenURL) {
        // userIdToken = this.authservice.getUserIdToken();
        userIdToken = this.authservice.getUserIdToken();
      //}
      const httpRequest = req.clone({
        headers: new HttpHeaders({
          "Cache-Control": "no-cache",
          "Pragma": "no-cache",
          "Expires": "Sat, 01 Jan 2000 00:00:00 GMT",
          //"Authorization":  this.authservice.getAuthorizationHeaderValue(),
          "id_token": userIdToken,
          //"Content-Type": "application/json"
        })
      });
      return next.handle(httpRequest);
    }
    else {
      let isSSORovokeToken = req.url.includes(ConfService.conf.environment.oidcConfig.revocation_endpoint) && req.method == "POST";
      const httpRequest = req.clone({
        headers: new HttpHeaders({
         "Authorization": this.authservice.getAuthorizationHeaderValue(),
         "Content-Type": isSSORovokeToken ? "application/x-www-form-urlencoded" : "application/json",
        })
      });
      return next.handle(httpRequest);
    }
    return next.handle(req);
  }
}
